import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BrushCleaning, Trash2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => { try { return iso ? new Date(iso).toLocaleDateString() : "—"; } catch { return "—"; } };

export const TestAccountSweep = ({ onSwept }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/admin/users/test-accounts`).then((r) => setData(r.data)).catch(() => setData({ accounts: [], total: 0 }));
  useEffect(() => { load(); }, []);

  const sweep = async () => {
    setBusy(true);
    try {
      const ids = (data?.accounts || []).map((a) => a.id);
      const r = await axios.post(`${API}/admin/users/test-accounts/sweep`, { confirm: "SWEEP", ids });
      toast.success(`Removed ${r.data.deleted} test account${r.data.deleted === 1 ? "" : "s"}.`);
      setOpen(false);
      load();
      onSwept?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sweep failed.");
    } finally {
      setBusy(false);
    }
  };

  const total = data?.total ?? 0;
  return (
    <div className="tacc-card p-4 md:p-5" data-testid="members-sweep-strip">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] flex items-center gap-2"><BrushCleaning size={12} className="text-[#B45309]" /> Test account sweep</div>
          <p className="text-xs text-[#A8A29E] mt-1 max-w-xl">
            Finds sign-ups that look like tests — emails at example.com / test.com, anything starting "launchcheck", or names saying "test" / "delete me". Never admins, never anyone who paid.
            {" "}<span className="text-[#44403C]" data-testid="members-sweep-count">{data ? `${total} found.` : "Looking…"}</span>
          </p>
        </div>
        <button onClick={() => setOpen((v) => !v)} disabled={!total} className="btn-outline text-xs whitespace-nowrap disabled:opacity-40" data-testid="members-sweep-open" aria-expanded={open}>
          <Trash2 size={13} /> {open ? "Close" : `Review & remove ${total}`}
        </button>
      </div>
      {open && (
        <div className="mt-4 border-t border-[#E7DFD5] pt-4" data-testid="members-sweep-list">
          <ul className="max-h-64 overflow-y-auto space-y-1.5 text-xs pr-2">
            {(data?.accounts || []).map((a) => (
              <li key={a.id} className="flex flex-wrap justify-between gap-2 text-[#44403C]" data-testid={`members-sweep-row-${a.id}`}>
                <span>{a.email} <span className="text-[#A8A29E]">{a.name ? `· ${a.name}` : ""}</span></span>
                <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#A8A29E]">{a.reason} · joined {fmt(a.created_at)}</span>
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap items-center gap-3 mt-4">
            <button onClick={sweep} disabled={busy} className="btn-ember text-xs disabled:opacity-50" data-testid="members-sweep-confirm">
              <Trash2 size={13} /> {busy ? "Removing…" : `Yes, remove all ${total}`}
            </button>
            <button onClick={() => setOpen(false)} className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] hover:text-[#1C1917]" data-testid="members-sweep-cancel">Cancel</button>
            <span className="text-[10px] text-[#A8A29E]">Their purchases (if any) stay on record, detached.</span>
          </div>
        </div>
      )}
    </div>
  );
};
